import { memo } from 'react'
import ListQueryToolbar from '../shared/ListQueryToolbar'

export const ORDER_SEARCH_DEBOUNCE_MS = 450

function OrdersSearchBar({
  appliedSearch = '',
  onApplySearchQuery,
  onClearFilters,
  isDefault = true,
  recent = [],
  onApplyRecent,
}) {
  return (
    <ListQueryToolbar
      label="Search orders"
      placeholder="TPN, DN, order #, sales order #, shop ID, or shop name…"
      debounceMs={ORDER_SEARCH_DEBOUNCE_MS}
      appliedSearch={appliedSearch}
      onApplySearchQuery={onApplySearchQuery}
      onClearFilters={onClearFilters}
      isDefault={isDefault}
      recent={recent}
      onApplyRecent={onApplyRecent}
      maxWidth={560}
      mb={0}
    />
  )
}

export default memo(OrdersSearchBar)
